import React from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Container, Grid, Typography } from '@material-ui/core';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

const ButtonIni = styled(Button)(({ theme }) => ({
    backgroundColor: '#A6C307',
    '&:hover': {
        backgroundColor: '#97b108',
        color: '#ffffff'
    },
}));

const NotFound = () => {
    const {t} = useTranslation();
    return (
        <>
            <Helmet>
                <title>{t('pageNotFoundTitle')}</title>
            </Helmet>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '100%',
                    justifyContent: 'center'
                }}
            >

                <Container maxWidth="md">
                    <Grid item xs={12} align='center'>
                        <Typography variant='h4'>{t('sorry')}</Typography>
                        <Typography variant='body1' color="textSecondary">{t('pageNotFoundMessage')}</Typography>

                        <Box sx={{ py: 2 }}>
                            <ButtonIni variant="contained" href="/">{t('backToHome')}</ButtonIni>
                        </Box>

                        <img
                            alt="Error 404"
                            src="/static/images/404.png"
                        />
                    </Grid>
                </Container>
            </Box>
        </>

    )
}
export default NotFound